module.exports = __webpack_public_path__ + "assets/img/logitechworkspace-lp-lifestyle.811d387c.jpg";